import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import { couponList } from "@/api/couponConfig.js";
import { syncCpConfig } from "@/api/data";
import { getCouponMap } from "@/utils/dictionary";
import couponOptions from "../../components/serverList/couponOptions.vue";
import infoList from "../../mixins/infoList";
import ShowCouponBatch from "./components/showCouponBatch.vue";
import ShowCouponGenerate from "./components/showCouponGenerate.vue";
export default {
  components: {
    ShowCouponBatch: ShowCouponBatch,
    ShowCouponGenerate: ShowCouponGenerate,
    couponOptions: couponOptions
  },
  name: "gameNotice",
  mixins: [infoList],
  data: function data() {
    return {
      nowStr: '',
      couponArray: [],
      listApi: couponList,
      selectedCoupon: null,
      tableData: [{
        coupon_id: 1
      }],
      couponBatchVisible: false,
      couponGenerateVisible: false
    };
  },
  created: function created() {
    var _this = this;
    getCouponMap().then(function (result) {
      for (var k in result) {
        _this.couponArray.push({
          couponId: k,
          couponName: result[k]
        });
      }
    });
    this.refresh();
  },
  methods: {
    refresh: function refresh() {
      this.refreshNowStr();
      this.getTableData();
    },
    openBatchDialog: function openBatchDialog(data) {
      this.selectedCoupon = data;
      this.couponBatchVisible = true;
    },
    openGenerateDialog: function openGenerateDialog() {
      this.couponGenerateVisible = true;
    },
    onGenerateDone: function onGenerateDone() {
      console.log(this.$refs.batchDialog);
      this.couponGenerateVisible = false;
      this.$refs.batchDialog.refresh();
    },
    openConfig: function openConfig() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return syncCpConfig({
                type: "c_coupon"
              });
            case 2:
              res = _context.sent;
              if (res.code === 0) {
                _this2.$message({
                  message: "同步cp配置成功",
                  type: "success"
                });
                _this2.refresh();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    refreshNowStr: function refreshNowStr() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var hour = now.getHours();
      var minute = now.getMinutes();
      var second = now.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      this.nowStr = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
    }
  }
};